module.exports = __webpack_public_path__ + "static/media/typescript.9a7e9b3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/skill/typescript.png
// module id = 116
// module chunks = 0